import { getAuth, signInWithEmailLink, isSignInWithEmailLink, signOut, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { db } from "../firebase/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { subscribeToPush } from "./firestoreService";

const auth = getAuth();
const googleProvider = new GoogleAuthProvider();

// 📌 **Magic Link senden**
export const sendMagicLink = async (email) => {
  try {
    window.localStorage.setItem("emailForSignIn", email);

    const response = await fetch("https://us-central1-htc-livematch.cloudfunctions.net/sendMagicLinkEmail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Fehler beim Senden des Magic Links");
    }

    return { success: true, message: "Magic Link wurde gesendet! Bitte überprüfe dein E-Mail-Postfach." };
  } catch (error) {
    console.error("Fehler beim Senden des Magic Links:", error);
    return { success: false, error: error.message };
  }
};

// 📌 **Magic Link erkennen & anmelden**
export const completeMagicLinkSignIn = async () => {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    let email = window.localStorage.getItem("emailForSignIn");

    if (!email) {
      email = window.prompt("Bitte gib deine E-Mail-Adresse ein:");
    }

    try {
      const result = await signInWithEmailLink(auth, email, window.location.href);
      window.localStorage.removeItem("emailForSignIn");

      const user = result.user;
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        await setDoc(userRef, { uid: user.uid, email: user.email, role: "htc", createdAt: new Date() });
        console.log("✅ Neuer Nutzer registriert:", user.uid);
      }

      // 🚀 Direkt prüfen, ob Push aktiviert wurde
      const subscribed = await subscribeToPush(user.uid);
      return { success: true, user, subscribed };
    } catch (error) {
      console.error("❌ Fehler beim Magic Link Login:", error);
      return { success: false, error: error.message };
    }
  }
};


// 📌 **Google Login mit Rolle & Subscription**
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;

    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      await setDoc(userRef, {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        role: "htc", // Standardrolle setzen
        createdAt: new Date(),
      });
      console.log("✅ Neuer Google-Nutzer registriert:", user.uid);
    }

    // 🚀 **Automatisch für Push-Benachrichtigungen registrieren**
    await subscribeToPush(user.uid);

    return { success: true, user };
  } catch (error) {
    console.error("Fehler beim Google Login:", error);
    return { success: false, error: error.message };
  }
};

// 📌 **Logout**
export const userLogout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Fehler beim Logout:", error);
  }
};
